export class CustomField {
    id: number;
    value: string;
}
